import _ from 'lodash';
import { Filter } from './types';

export interface FilterBuilderInterface {
  filters: Filter[];

  addFilters(...filters: Filter[]): FilterBuilderInterface;
  isEmpty(): boolean;
  build(): string;
  reset(): void;
}

export default class FilterBuilder implements FilterBuilderInterface {
  #filters: Filter[] = [];

  get filters() {
    return _.cloneDeep(this.#filters);
  }

  addFilters(...filters: Filter[]) {
    this.#filters.push(...filters);

    return this;
  }

  isEmpty(): boolean {
    return !(this.#filters && this.#filters.length);
  }

  reset() {
    this.#filters = [];
  }

  build() {
    if (!this.#filters.length) return '';
    const reducedFilters = this.#filters.reduce(this.reduceFilters);
    const serialized = this.serializeReducedFilters(reducedFilters);

    return serialized;
  }

  private reduceFilters(prevFilter: Filter, curFilter: Filter) {
    return _.merge({}, prevFilter, curFilter);
  }

  private serializeReducedFilters(reducedFilters: Filter) {
    const stringified = JSON.stringify(reducedFilters);
    return stringified;
  }
}
